export const MANAGE_GIVING_LINK_DIALOG_TITLE = 'manage-giving-link-dialog.title';
export const MANAGE_GIVING_LINK_DIALOG_ICON_ALT = 'manage-giving-link-dialog.icon-alt';
